import Options from '../../../../store/bookable-objects/options';

angular
    .module('festzelt-os.modules.bo')
    .factory('BoOptions', [
        '$injector',
        'BoOption',
        ($injector, BoOption) => new Options(BoOption, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/store/options.js